import React, { useState } from 'react'

import {Link, useHistory} from 'react-router-dom';


export default function ProfileSettingChild({mobileCheck, setMobileCheck}) {
    
    const history = useHistory();
    const [selected, setSelected] = useState('Profile');
    // console.log('history',history.location.pathname)

    const items  =   [
                {
                    text            :   'Profile',
                    link            :   'profile',
                },
        ]   

    const handleClick = (element) => {
        // setMobileCheck(false);
        setSelected(element.text)
    }   

    return (
        <div>
            <div class="headingH3 sidebarHeading">Profile</div>
            <div className="items mt-36">
                {
                    items.map((element, idx)=>(
                        <div key={idx}> 
                            <Link  to={element.link} onClick={()=> handleClick(element)}>
                                <div className={(element.text === selected) ? 'active subtitle2 item': 'subtitle2 item'}>
                                    {element.icon}
                                    <span className="pl-8">{element.text}</span>
                                </div>
                            </Link>
                        </div>
                    ))
                }
            </div>  
        </div>
    )
}

